import { Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';

import { useSelector, useDispatch } from 'react-redux';

import { useInjectReducer } from 'utils/redux-injectors';

import { selectAlert } from './selectors';
import { reducer, sliceKey, actions } from './slice';

export function Alert() {
  useInjectReducer({ key: sliceKey, reducer: reducer });

  const alert = useSelector(selectAlert);
  const dispatch = useDispatch();

  const handleToastClose = () => {
    dispatch(actions.close());
  };

  return (
    <>
      <Snackbar
        open={alert.open}
        autoHideDuration={6000}
        onClose={() => handleToastClose()}
        anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
      >
        <MuiAlert severity={alert.severity} onClose={() => handleToastClose()}>
          {alert.message}
        </MuiAlert>
      </Snackbar>
    </>
  );
}
